import ModuleWindowControls from '@/components/mosaic/ModuleWindowControl';
import useLanguage from '@/utils/hooks/useLanguage';
import { tabIcon } from '@/utils/hooks/useXplorSpotLayout';
import ModuleWindow, { moduleHeaderClassName } from './ModuleWindow';

const FeatureModule = (props: any) => {
    const { screen, tradingModule } = props;

    const lang = useLanguage();

    return (
        <ModuleWindow
            {...props}
            renderToolbar={() => (
                <div className={moduleHeaderClassName} dir={lang.dir}>
                    <div className="h-full flex items-center p-2 gap-2">
                        {tabIcon[tradingModule?.title || ''] && (
                            <div className="flex items-center justify-center bg-brand-neutral-700 rounded-full p-1">
                                {tabIcon[tradingModule?.title || '']({
                                    className: 'w-4 h-4',
                                    'aria-hidden': true
                                })}
                            </div>
                        )}
                        <span className="font-semibold">{tradingModule?.title}</span>
                    </div>
                    <ModuleWindowControls screen={screen} />
                </div>
            )}>
            {tradingModule?.component}
        </ModuleWindow>
    );
};

export default FeatureModule;
